import React from 'react'
import Topbar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import BreadCrumb from '../../Globle/Breadecrumb'
import Footer1 from '../../Globle/Footer1'
import BreadCrumbimage2 from '../Mainsidebarshop2/BreadCrumbimage2'
import FillterDetails from '../Mainsidebarshop1/FillterDetails'

const Main = () => {
    return (
        <>
            <Topbar />
            <Header />
            <Navigation />
            <BreadCrumb title='Shop' />
            <BreadCrumbimage2 />
            <FillterDetails />
            <Footer1 />
        </>
    )
}

export default Main
